import React from "react";
import { motion } from "framer-motion";

import heroImg from "../../assets/Home/heroImg.jpg";
import heroImgNoBg from "../../assets/Home/heroImgNoBg.png";

// components

// custom hooks
import useTheme from "../../hooks/useTheme";

const heroImageVariants = {
	initial: {
		opacity: 0,
		x: -100,
	},
	animate: {
		opacity: 1,
		x: 0,
	},
	exit: {
		opacity: 0,
		x: -100,
	},
	transition: {
		duration: 0.5,
	},
};

const HeroImage = () => {
	const { theme } = useTheme();

	return (
		<motion.div
			variants={heroImageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition="transition"
			className={`${
				theme === "dark"
					? "border-white bg-white"
					: "border-black bg-gradient-to-t from-black"
			} border-2 rounded-full overflow-hidden cursor-grab active:cursor-grabbing max-w-sm lg:max-w-xl`}>
			<motion.img
				drag
				dragConstraints={{ top: 0, left: 0, bottom: 0, right: 0 }}
				dragElastic={0.5}
				whileDrag={{ scale: 0.8 }}
				src={theme === "dark" ? heroImg : heroImgNoBg}
				alt="my hero photo"
				className={`${
					theme === "dark" ? "" : "bg-gradient-to-t from-black"
				} h-auto max-w-full rounded-full`}
			/>
		</motion.div>
	);
};

export default HeroImage;
